"use client";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Progress } from "@/components/ui/progress";

const Loader = () => {
  const [progress, setProgress] = useState(0);

  // Animate the progress bar
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 5;
        return next >= 100 ? 100 : next;
      });
    }, 200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center  z-50 px-6">
      {/* Logo */}
      <Image
        src="/sortkaro_login_logo.png"
        alt="SortKaro Logo"
        width={180}
        height={180}
        className="mb-4"
        loading="eager"
        priority
        style={{ width: 'auto', height: 'auto' }}
      />

      {/* Progress Bar with custom color */}
      <Progress
        value={progress}
        className="w-full max-w-sm h-1"
        // If you want inline style
      />
    </div>
  );
};

export default Loader;
